<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
			<span class="page-title">Assets</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Messages, links and files flagged as malicious or sensitive</span>
		</div>
	</div>
	<div class="page-inner-content-holder no-scroll flxClmn">
		<trustifi-table-c #assetsTable
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="assets"
			[headers]="[
				{text: 'Detected', sortKey: 'created', width: '90px'},
				{text: 'User', sortKey: 'user'},
				{text: 'Resource', sortKey: 'resource_id.name', width: '20%'},
				{text: 'Type', sortKey: 'asset_type', width: '90px'},
				{text: 'Category', sortKey: 'category', width: '115px'},
				{text: 'Detection Details'},
				{text: 'Access', sortKey: 'accessWeight', width: '130px'},
			]"
			[cellsPrototype]="[
				{html: 'createdCell'},
				{textKey: 'user'},
				{html: 'resourceCell'},
				{html: 'typeCell'},
				{html: 'categoryCell'},
				{html: 'detectionCell'},
				{html: 'accessCell'},
			]"
			[bulkActions]="{
				enable: true,
				selectBulkActionCb:	selectBulkAction,
				initBulkActionsFunction: showAssetsBulkActions
			}"
			[cellActions]="{
				enable: true,
				selectItemActionCb:	selectAssetAction,
				initActionsFunction: showAssetActions,
				showInRed: {enable: true, terms: ['Delete']}
			}"
			[filterData]="filterData"
			(searchFunction)="searchAssets($event.searchTerm, $event.activeFilters)"
			[options]="{
                exportToCsvFunction: exportToCsv,
                loadingTableFlag: loadingAssets,
                refreshFunction: getCollaborationAssets,
                itemsNameSingular: 'asset',
                defaultSortKey: '-created',
            }"
		>
			<ng-template #customCells let-item let-cellId="cellId">

				<!--Detected date-->
				<span *ngIf="cellId === 'createdCell'"
					  style="white-space: normal; text-overflow: unset; text-align: center; display: block; max-width: min-content;">
					{{item.created | date:'MM/dd/yyyy HH:mm'}}
				</span>

				<!--Resource: name + source type chip-->
				<div class="flex-column gap-1" *ngIf="cellId === 'resourceCell'">
					<span class="ellipsis">{{item.resource_id?.name || 'N/A'}}</span>
					<div class="flex-row gap-1 align-items-center">
						<span class="resource-type-chip">
							<i class="far" [ngClass]="{
								'fa-hashtag': item.resource_id?.resource_type === 'channel',
								'fa-comments': item.resource_id?.resource_type === 'chat',
								'fa-video': item.resource_id?.resource_type === 'meeting',
								'fa-globe': item.resource_id?.resource_type === 'site',
								'fa-cloud': item.resource_id?.resource_type === 'OneDrive'
							}"></i>
							{{item.resource_id?.resource_type || 'N/A'}}
						</span>
						<span class="resource-type-chip" *ngIf="item.resource_id?.resource_sub_type && item.resource_id?.resource_sub_type !== item.resource_id?.resource_type">
							<i class="far" [ngClass]="{
								'fa-globe': item.resource_id?.resource_sub_type === 'site',
								'fa-hashtag': item.resource_id?.resource_sub_type === 'channel',
								'fa-user': item.resource_id?.resource_sub_type === 'personal'
							}"></i>
							{{item.resource_id?.resource_sub_type}}
						</span>
					</div>
				</div>

				<!--Type: file/message with icon-->
				<div class="flex-column gap-1" *ngIf="cellId === 'typeCell'">
					<div class="flex-row gap-1 align-items-center">
						<i class="far" style="font-size: 11px; color: #64748b;" [ngClass]="{
							'fa-file-alt': item.asset_type === 'file',
							'fa-comment-alt': item.asset_type === 'message'
						}"></i>
						<span>{{item.asset_type | titlecase}}</span>
					</div>
					<span *ngIf="item.asset_type === 'file' && item.size" style="font-size: 11px; color: #64748b;">{{item.size | FormatBytes}}</span>
				</div>

				<!--Category: colored badge for DLP or Malicious-->
				<div *ngIf="cellId === 'categoryCell'">
					<div class="category-badge category-dlp" *ngIf="item.category === 'DLP'">
						<i class="fas fa-shield-alt"></i>
						<span>DLP</span>
						<span class="sensitivity-score-badge"
							  [ngStyle]="{'background': sensitivityScoreColor(item.sensitivity_info?.score ?? 0)}">
							{{item.sensitivity_info?.score ?? 0}}
						</span>
					</div>
					<div class="category-badge category-malicious" *ngIf="item.category === 'Malicious'">
						<i class="far fa-bug"></i>
						<span>{{item.malicious_info?.status || 'Malicious'}}</span>
					</div>
					<div class="category-badge category-rules"
						 *ngIf="item.category === 'Rule'"
						 [tooltip]="item.info?.rule_name ? 'Rule: ' + item.info?.rule_name : null">
						<i class="far fa-list"></i>
						<span style="text-decoration: underline; text-decoration-style: dotted;">Rules</span>
					</div>
				</div>

				<!--Detection Details: sensitive types or malicious sub-category-->
				<div *ngIf="cellId === 'detectionCell'" class="flex-column gap-1">
					<!--DLP details-->
					<ng-container *ngIf="item.category === 'DLP'">
						<div class="flex-row gap-1 flex-wrap justify-content-start">
							<span class="detection-tag detection-tag-dlp" *ngFor="let type of item._topSensitiveTypes">
								{{type}}
							</span>
						</div>
						<span class="opacity-50" style="font-size: 11px;" *ngIf="item.sensitivity_info.sensitive_types?.length > 3">
							+{{item.sensitivity_info.sensitive_types.length - 3}} more
						</span>
					</ng-container>

					<!--Malicious details-->
					<ng-container *ngIf="item.category === 'Malicious'">
						<div class="flex-column gap-1">
							<div class="flex-row gap-1 flex-wrap justify-content-start" *ngIf="item._maliciousSubCategory?.length">
								<span class="detection-tag detection-tag-malicious" *ngFor="let msg of item._maliciousSubCategory">
									{{msg}}
								</span>
							</div>
							<span class="opacity-75 ellipsis" style="font-size: 11px;" *ngIf="item.malicious_info?.domain"
								  tooltip="{{item.malicious_info?.url}}" placement="top">
								{{item.malicious_info?.domain}}
							</span>
						</div>
					</ng-container>

					<!--DLP details-->
					<ng-container *ngIf="item.category === 'Rule'">
						<span *ngIf="item.info?.rule_name">
							Rule: {{item.info.rule_name}}
						</span>
					</ng-container>
				</div>

				<!--Access: members count + permission scope-->
				<div *ngIf="cellId === 'accessCell' && !item.is_quarantine" class="flex-column gap-1">
					<div class="flex-row gap-1 align-items-center" *ngIf="item.resource_id?.members?.length">
						<i class="far fa-users" style="font-size: 10px; color: #64748b;"></i>
						<span tooltip="{{item.resource_id?.members?.join('\n')}}" placement="top" class="members-hover-link" style="font-size: 12px;">{{item.resource_id?.members?.length}} member{{item.resource_id?.members?.length !== 1 ? 's' : ''}}</span>
						<span class="external-badge" *ngIf="item.resource_id?.external_members?.length"
							  tooltip="{{item.resource_id?.external_members?.join('\n')}}" placement="top">
							{{item.resource_id?.external_members?.length}} ext
						</span>
					</div>
					<div class="flex-row gap-1 align-items-center" *ngIf="item.permissions?.link?.scope"
						 (click)="$event.stopPropagation();">
						<i class="far fa-exclamation-triangle text-warning" style="font-size: 10px;"
						   *ngIf="item.permissions?.link?.scope === 'anonymous'"
						   tooltip="This file is publicly accessible">
						</i>
						<span class="permission-scope-chip"
							  [ngClass]="{
								'scope-anonymous': item.permissions?.link?.scope === 'anonymous',
								'scope-external': item.permissions?.link?.scope === 'external',
								'scope-organization': item.permissions?.link?.scope === 'organization',
								'scope-users': item.permissions?.link?.scope === 'users'
							  }">
							{{item.permissions?.link?.scope | titlecase}}
						</span>
						<i style="font-weight: 400; font-size: 11px;" class="far fa-question-circle opacity-50"
						   [tooltip]="linkScopeTooltips[item.permissions?.link?.scope]" placement="right"></i>
					</div>
				</div>

				<div *ngIf="cellId === 'accessCell' && item.is_quarantine" style="color: red;">
					Quarantined
				</div>

			</ng-template>
		</trustifi-table-c>

	</div>
</div>

<collaboration-asset-info
	*ngIf="currentAssetInfoObj"
	[asset]="currentAssetInfoObj"
	(closeCb)="currentAssetInfoObj = null;">
</collaboration-asset-info>
